LoadingHandler = App.loadClass "core::FullPageLoadingHandler"
ValidationEngine = App.loadClass "core::ValidationEngine"
ScrollHelper = App.load "core::ScrollHelper"

class exports.Hybrids_Dialog extends FullPageHandler

    init: () ->
        @layoutUrl  = 'backend/portal/hybrids/report'
        @saveUrl    = 'backend/portal/hybrids/save-inventory'
        @excelUrl   = 'backend/portal/hybrids/excel'

        @param_filters = ko.toJSON @parent.sidebar.jsonize()

        opt = postOptions:
            query: @param_filters

        @createDialog( opt )

        @loader = @createSubHandler LoadingHandler
        if @loader
            @loader.init("Loading Inventory...")


    updateAvailableForHybridRow: (index, Element) ->
        # Calculate and update available based on forecasted
        forecasted = $(this).find('.hybrids-forecasted-input').val()
        available = $(this).find('.available')[0].outerText
        if not forecasted and available
            forecasted = 0
        if not isNaN(parseFloat(forecasted)) and isFinite(forecasted)
            ordered = $(this).find('.ordered').html()
            available = forecasted - ordered
            $(this).find('.available').html(available)


    updateCounts: () ->
        # Update the 'available' column to reflect changes to the 'forecasted' column
        $('.hybrids-line').each(@updateAvailableForHybridRow)


    validationPassed: () ->
        @updateCounts()

        #get save data
        @saveData = 'hybrids': {}

        for h in @dialog.find('input.to-save.hybrids-forecasted-input')
            hybrid_id = $(h).data('hybrid-id')

            if not @saveData['hybrids'][hybrid_id]?
                @saveData['hybrids'][hybrid_id] = {}

            @saveData['hybrids'][hybrid_id]['forcasted'] = $(h).val()

        for hd in @dialog.find('input.to-save.hybrid-checkbox')
            hybrid_id = $(hd).data('hybrid-id')

            if not @saveData['hybrids'][hybrid_id]?
                @saveData['hybrids'][hybrid_id] = {}

            @saveData['hybrids'][hybrid_id]['disabled'] = $(hd).prop('checked')

        for s in @dialog.find('input.to-save.lot-checkbox')
            hybrid_id = $(s).data('hybrid-id')
            lot_id = $(s).data('lot-id')

            if not @saveData['hybrids'][hybrid_id]?
                @saveData['hybrids'][hybrid_id] = {}

            if not @saveData['hybrids'][hybrid_id]['lots']?
                @saveData['hybrids'][hybrid_id]['lots'] = {}

            @saveData['hybrids'][hybrid_id]['lots'][lot_id] = $(s).prop('checked')

        @save('Saving Inventory...')


    afterLoadLayout: (selector, response) ->
        @loader.closeDialog()
        @openDialog()

        if response.status?.type isnt 'success'
            return

        # If input is touched add to-save class
        $(":text, :checkbox").bind 'focus', () ->
            $(this).addClass('to-save')

        # Prune expandable hybrids with no lots
        $('.hybrids-line-expandable').each () ->
            # console.log $(this).data('hybrid-id')
            id = $(this).data('hybrid-id')
            if $("[data-parent-hybrid-id='#{id}']").length is 0
                $(this).find('.header-icon').remove()
                $(this).removeClass 'hybrids-line-expandable'
                $(this).addClass 'hybrids-nonexpandable-spacer'

        # Prune expandable lots with no locations
        $('.lots-line-expandable').each () ->
            id = $(this).data('lot-id')
            if $("[data-parent-lot-id='#{id}']").length is 0
                $(this).find('.header-icon').remove()
                $(this).removeClass 'lots-line-expandable'
                $(this).addClass 'lots-nonexpandable-spacer'

        # Collapse / expand hybrids
        $('.hybrids-line-expandable').bind 'click', () ->
            id = $(this).data('hybrid-id')
            $("[data-parent-hybrid-id='#{id}']").toggleClass('hidden-by-hybrid')
            $(this).find('.header-icon').toggle()

        # Collapse / expand lots
        $('.lots-line-expandable').bind 'click', () ->
            id = $(this).data('lot-id')
            $("[data-parent-lot-id='#{id}']").toggleClass('hidden-by-lot')
            $(this).find('.header-icon').toggle()

        # Add masking to the forecasted inputs
        @dialog.find('input.hybrids-forecasted-input').mask '?999999999', { placeholder: '' }

        # Set up validation
        @validator = new ValidationEngine()
        @validator.makeFormValidator 'hybrids', '#hybrids_form', '.errorDiv', (valid) =>
            if valid
                # Perform an action if the form successfully validated
                @validationPassed()
            else
                # Perform an action if the form validation failed

        @dialog.find('.save-btn').bind 'click', () =>
            @validator.validateAll()

        @dialog.delegate '.excel-btn', 'click', (e) =>
            url = "#{@excelUrl}?query=#{encodeURIComponent(@param_filters)}"
            window.open(url, '_blank')

        # Cancel dialog changes by reloading the dialog
        @dialog.find('.cancel-btn').removeAttr('data-dismiss').bind 'click', () =>
            @refresh()

        size = @dialog.find('.modal-body').height() - 40
        @table = @dialog.find(".table").dataTable
            sScrollY: size + "px"
            bPaginate: false
            bFilter: false
            bInfo: false
            bSort: false

        $(window).unbind('modal_resized').bind 'modal_resized', debounce (e) =>
            if @table?.fnSettings()?
                size = @dialog.find('.modal-body').height() - 40
                @table.fnSettings().sY = "#{size}px"
                @dialog.find('.dataTables_scrollBody').height(size)
                @table.fnAdjustColumnSizing()
